var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 2.702L18.8.4 4.4 2H2.8L.4 10.4l18.4 5.2 2.4-8.8h-.8l.4-2H20l-.2-2.097h-.7z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.133 7.679L13.8 5.974a3.99 3.99 0 01-1.758 6.591l6.334 1.705 1.758-6.591zm-2.747 2.474l-.058-.993-.545.831-.959-.251.618.777-.534.838.928-.35.628.77-.045-.995.922-.363-.955-.264z",
    fill: "url(#paint0_linear_377_13612)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12 7.708a3.97 3.97 0 012.735-2.796L3.496 3.201 1.738 9.79l6.358 1.712a3.991 3.991 0 01-.975-3.795zm-1.884-.825l-.058-.993-.545.83-.959-.25.619.777-.534.838.927-.35.628.769-.045-.994.922-.363-.955-.264z",
    fill: "url(#paint1_linear_377_13612)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 7.452l1.894.51 1.06-1.621.111 1.936 1.894.51-1.825.687.11 1.937-1.239-1.512-1.826.687 1.06-1.622-1.24-1.512z",
    fill: "url(#paint2_linear_377_13612)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.628 2.13L19.368 0 4.042 1.89l-1.559-.42L0 10.782 19.388 16l2.484-9.31-.876-.237.311-1.975-.773-.123-.038-2.24-.868.015zm-7.03.962l7.064-.124.021 1.251-.577-.092-.01-.58-3.278.057-3.22-.512zM7.6 2.297L18.628.937l.147 1.207-.579.01-.07-.582-5.522.68-4.757.084-.247-.04zm2.714 1.281l10.025 1.595-.167 1.059-.56-.15.07-.438-4.138-.658-5.23-1.408zM3.087 2.502l17.749 4.777-2.051 7.69-17.75-4.778 2.052-7.69z",
    fill: "url(#paint3_linear_377_13612)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_377_13612",
    x1: 11.2,
    y1: 2.8,
    x2: 11.14,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73DE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_377_13612",
    x1: 11.2,
    y1: 2.8,
    x2: 11.14,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73DE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_377_13612",
    x1: 11.2,
    y1: 2.8,
    x2: 11.14,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73DE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_377_13612",
    x1: 11.2,
    y1: 2.8,
    x2: 11.14,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73DE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9500"
  })))));
}
SvgIconCash.displayName = 'IconCash';
export default SvgIconCash;